import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { DeviceDistributionPieChart } from "./charts/DeviceDistributionPieChart/DeviceDistributionPieChart";
import { DeviceDistributionSingleChart } from "./charts/DeviceDistributionSingleChart/DeviceDistributionSingleChart";
import { DeviceDistributionChartContainer } from "./DeviceDistributionChart.styles";

export const DeviceDistributionChart: FC = () => {
    const { state, params } = useCurrentStateAndParams();
    const isFullWidth = state.name === "market_research_overview" || state.name === "market_research_overview_v2";
    const { webSource } = params;

    return (
        <DeviceDistributionChartContainer isFullWidth={isFullWidth}>
            {webSource === "Total" ? (
                <DeviceDistributionPieChart webSource={webSource} />
            ) : (
                <DeviceDistributionSingleChart webSource={webSource} />
            )}
        </DeviceDistributionChartContainer>
    );
};
